import { LOCALES, type Locale } from '@brig/api-types';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { currentLocale, ENDONYMS } from '../i18n/index.ts';
import * as styles from './LanguageSwitcher.css.ts';

interface LanguageSwitcherProps {
  /** Called after the UI language changed (e.g. to persist it in the profile). */
  onChange?: (locale: Locale) => void;
  tone?: 'sea' | 'paper';
}

/** Compact language select for headers. */
export function LanguageSwitcher({ onChange, tone = 'sea' }: LanguageSwitcherProps) {
  const { t, i18n } = useTranslation();
  const id = useId();
  return (
    <div className={styles.root({ tone })}>
      <label htmlFor={id} className={styles.label}>
        {t('nav.language')}
      </label>
      <select
        id={id}
        className={styles.select({ tone })}
        value={currentLocale()}
        onChange={(event) => {
          const locale = event.target.value as Locale;
          void i18n.changeLanguage(locale).then(() => onChange?.(locale));
        }}
      >
        {LOCALES.map((locale) => (
          <option key={locale} value={locale} lang={locale}>
            {ENDONYMS[locale]}
          </option>
        ))}
      </select>
    </div>
  );
}
